module.exports = __webpack_public_path__ + "static/scale-model-of-louisville-nature-center-in-louisville-kentucky-20525f78d016704f11fb9b389d865e5d.png";